import { useQuery } from 'react-query'
import { fetchContacts } from '../api/api'
import { useChosenCompany } from '../context/UserProvider'

export const useContacts = (id: string = '') => {
  const company = useChosenCompany()
  const companyId = company?.id

  const {
    data: contacts,
    isLoading,
    refetch,
    isRefetching,
  } = useQuery(['contacts', companyId], () => fetchContacts(companyId), {
    enabled: !!companyId,
  })

  const list = Array.isArray(contacts) ? (contacts as any[]) : []

  return {
    isRefetching,
    refetch,
    contacts,
    currentContact: list.find((contact) => contact.id === id),
    isLoading,
  }
}
